import {SERVICES} from '@/const';

const IMG_URL = 'https://img.phemex.com';

export const IMAGES = {
  SIMPLEX: '/v1/69a820fd/simplex.png',
  BIND_A_CARD: '/v1/d50ee580/bind-a-card.png',
  COMPLETE_PAYMENT: '/v1/af7294bb/step3-2x.png',
  COMPLETED: '/v1/8dc0b0ee/completed.png',
  ERROR: '/v1/f4f26239/error.png',
  FAILED: '/v1/7c2c1735/failed.png',
  FIAT_BALANCE_ACCOUNT: '/v1/09780b96/fiat-balance-account.png',
  FIAT_BALANCE_V2: '/v1/2c9b91e5/fiat-balance.png',
  KYC_IDENTITY: '/v1/4c0fc21d/step2-2x.png',
  SUPPORT_PAYMENT: '/v1/ff69ef76/support-payment.png',
  ALL_PAYMENT_METHODS: '/v1/f9df6057/all-payment-methods.png',
  ULTRA_LOW_FEE: '/v1/0a538bcc/ultra-low-fee.png',
  SUPER_FAST_SETTLEMENT: '/v1/39c0c9ff/super-fast-settlement.png',
  NO_PAYMENT_METHOD: '/v1/8e8bfaf7/no-payment-method.png',
  NO_TRANSACTION_FEES: '/v1/369aedfe/no-transaction-fees.png',
  SIGN_UP: '/v1/6226ce71/step1-2x.png',
  TRADE_WITH_PRIVACY: '/v1/8b0a63e1/trade-with-privacy.png',
  TRADING_REQUIREMENTS: '/v1/eca643fd/trading-requirements.png',
  LINE: '/v1/e9bca3e5/line.png',
  BANK_BLUE: '/v1/44f04960/bank-blue.png',
  FIAT_ACCOUNT_ICON: '/v1/38eaa16deb95cba8/fiat-account.svg',
  FIAT_DEPOSIT_ICON: '/v1/fdb0db8eb05c2178/fiat-deposit.svg',
  ONE_CLICK_ICON: '/v1/e978c255ca365b23/one-click.svg',
  ADD_A_CARD: '/v1/173f4fa5/add-a-card.png',
  TRANSAK: '/v1/7ed8c681-8969-4330-8567-8305ffcbdb99/transak.svg',
};
Object.keys(IMAGES).forEach((key) => (IMAGES[key] = [IMG_URL, IMAGES[key]].join('')));

export const BANK_IMAGES = {
  VISA: '/s/home/buy-crypto/visa.png',
  MASTERCARD: '/s/home/buy-crypto/master.png',
  BANKTRANSFER: '/s/home/buy-crypto/banktransfer.png',
  SEPA: '/s/home/buy-crypto/sepa.png',
  POLI: '/s/home/buy-crypto/poli.png',
  PAYID: '/s/home/buy-crypto/payid.png',
  IDEAL: '/s/home/buy-crypto/ideal.png',
  PIX: '/s/home/buy-crypto/pix.png',
};
Object.keys(BANK_IMAGES).forEach((key) => (BANK_IMAGES[key] = [SERVICES.STATIC_URL, BANK_IMAGES[key]].join('')));
